import { makeVar, useReactiveVar } from '@apollo/client'

const notificationVar = makeVar(null)
export const raiseNotification = (type) => {
  notificationVar({ type })
}
export const clearNotification = () => notificationVar(null)
export const useNotificationVar = () => useReactiveVar(notificationVar)
